// Only Perm Features (Should be marked as a permanent flag in LaunchDarkly)
export const FeatureFlags = {
  AdditionalBlogUrls: 'Web.AdditionalBlogUrls',
  AgentLanderUrl: 'Web.AgentLanderUrl',
  AgentLandingPartnerships: 'Web.AgentLandingPartnerships',
  AircallPhoneNumbers: 'Web.AircallPhoneNumbers',
  AwardsConfig: 'Web.AwardsConfig',
  AwardsCurrentYear: 'Awards.CurrentYear',
  BrandFooterLink: 'Web.FooterBrandUrl',
  BrokerageAttribution: 'Web.BrokerageAttribution',
  ContactSalesPhoneNumber: 'Web.ContactSalesPhoneNumber',
  ContactUsUrl: 'Web.ContactUsUrl',
  CorporatePlans: 'Web.CorporatePlans',
  DashboardEnableCorporateLeaderboard: 'Dashboard.EnableCorporateLeaderboard',
  DisableCloudinary: 'Web.DisableCloudinary',
  EnableBuyerAgents: 'Core.EnableBuyerAgents',
  EnableCustomAds: 'Web.EnableCustomAds',
  EnableEnquiryTypeSelectionOnMarketUpdateLandingPages: 'LandingPages.MarketUpdate.AllowEnquiryType',
  EnableFinance: 'Core.EnableFinance',
  EnableFreeTrialCta: 'Public.EnableFreeTrialCta',
  EnableHomepageAgentCta: 'EnableHomepageAgentCta',
  EnableHomepageCaseStudies: 'EnableHomepageCaseStudies',
  EnableImageCaching: 'Web.EnableImageCache',
  EnableIntercom: 'Web.EnableIntercomLiveChat',
  EnableLeadAgentDisclaimer: 'Web.EnableLeadAgentDisclaimer',
  EnableLeasing: 'Web.EnableLeasing',
  EnableListingAttribution: 'Web.EnableListingAttribution',
  EnableMlsFooterLink: 'Web.ShowMlsLicensingFooterLink',
  EnableMobileNumberForMarketReport: 'Core.EnableMobileNumberForMarketReport',
  EnableNewOfficeSubscriptions: 'Web.EnableNewOfficeSubscriptions',
  EnableSettlementPeriod: 'Core.EnableSettlementPeriod',
  EnableTeams: 'Core.EnableTeams',
  EnableUnrequestedReviews: 'Core.EnableUnrequestedReviews',
  ExternalReviewSourceAttributionBlacklist: 'Public.ExternalReviewSourceAttributionBlacklist',
  FaqFooterLink: 'Web.FooterFaqUrl',
  FeaturedVideoReviews: 'Web.FeaturedVideoReviews',
  FindMyAgentPopupBanner: 'FindMyAgent.PopupBanner',
  FindMyAgentPropertyTypes: 'FindMyAgent.PropertyTypes',
  FindMyAgentSearchBanner: 'FindMyAgent.SearchBanner',
  FloatingHeads: 'Web.ConsumerHomeFloatingHeads',
  FooterAwardsUrl: 'Web.FooterAwardsUrl',
  FooterShowSupportEmailToUnsubscribedUsers: 'Web.FooterShowSupportEmailToUnsubscribedUsers',
  FooterShowSupportNumberToUnsubscribedUsers: 'Web.FooterShowSupportNumberToUnsubscribedUsers',
  HasMandatoryLicenceField: 'HasMandatoryLicenceField',
  HideAddressSearch: 'Public.HideAddressSearch',
  HomePageBrokerageLink: 'Web.HomePageBrokerageLink',
  HomepageSearchImage: 'Web.HomepageSearchImage',
  LiveBy: 'Core.LiveBy',
  MarketingBaseUrl: 'Web.MarketingBaseUrl',
  PropertyTypeGrouping: 'Web.PropertyTypeGrouping',
  RenownedBaseUrl: 'Web.RenownedBaseUrl',
  SaleMethodInsights: 'Web.SaleMethodInsights',
  ShowPendingPropertyStat: 'LandingPages.ShowPendingPropertiesStat',
  ShowReviewsOnListingLandingPages: 'LandingPages.Listing.ShowReviews',
  SubscriptionTierChannels: 'Web.SubscriptionPlanIntegrations',
  SupportCentreUrl: 'Core.SupportCentreUrl',
  SupportEmail: 'Web.SupportEmail',
  TeamsBillingGrouping: 'Web.TeamsBillingGrouping',
  TrainingWebinarUrl: 'TrainingWebinarUrl',
  TypeformSurvey2023Snippet: 'Web.TypeformSurvey2023Snippet',
  UnlockEnquiryTypeOnMarketUpdateLandingPages: 'LandingPages.MarketUpdate.UnlockEnquiryType',
  UnlockOnMarketUpdateLandingPages: 'LandingPages.MarketUpdate.Unlock',
  UseSourceListingStatus: 'Core.UseSourceListingStatus',
  ConsumerPostReviewSurvey: 'Web.ConsumerPostReviewSurvey',
} as const;

// Temporary Features
export const TempFeatureFlags = {
  CompareTray: 'Temp.Public.CompareTray',
  EnableBrokerageProInterestCheck: 'Temp.EnableBrokerageProInterestCheck',
  FindMyCtaAlternateCopy: 'Temp.FindMyCtaAlternateCopy',
  HideDom: 'Temp.Public.HideDOM2023',
  OfficeSubscriptionContactRequest: 'Web.OfficeSubscriptionContactRequest',
  SpanishReviews: 'Temp.EnableSpanishReviewFlow',
  CreateProfileTrackCountryIndustryRole: 'Temp.CreateProfileTrackCountryIndustryRole',
  ShowNewComparisonTable: 'Temp.ShowNewPlanComparisonTable',
  SellerLeadCaptureEnabled: 'Temp.SellerLeadCaptureEnabled',
  // The recipient profileCode that seller leads (and nurture captures) are sent to,
  // for manual wizard-of-oz follow-up. Held in config so it's set per environment in
  // LaunchDarkly rather than hardcoded.
  SellerLeadCaptureCtoProfileCode: 'Temp.SellerLeadCaptureCtoProfileCode',
} as const;

// Experiments Features
export const ExperimentFlags = {
  // Two-arm: buckets the homepage seller-intent band into three-routes (agent finder / seller flow /
  // compare tool) or single-route (one CTA to the agent finder). Unbucketed visitors — and every
  // value that is neither arm — get no band at all, so this flag alone gates the whole placement.
  HomepageBandVariant: 'Experiment.HomepageBandVariant',
  NlpSearch: 'Experiment.NlpSearch',
  SearchResultsBannerCopy: 'Experiment.SearchResultsBannerCopy',
  // Multivariate: buckets the /sell funnel after the address step into control (find-my redirect),
  // property-value (property-value screen) and best-agent (best-agent screen). SellerLeadCaptureEnabled
  // stays the master on/off gate; this only chooses the arm once the funnel is on.
  SellerLeadCaptureVariant: 'Experiment.SellerLeadCaptureVariant',
  // Two-arm copy test on the find-my-agent banner shown under a locality's sold-listings page.
  // Both arms show the banner and differ only in the heading; an unresolved flag or an unbucketed
  // visitor sees no banner at all, so this doubles as the on/off gate for the placement.
  SuburbSoldBannerVariant: 'Experiment.SuburbSoldBannerVariant',
} as const;

// The variation values the SellerLeadCaptureVariant flag serves in LaunchDarkly — the kebab-case
// variation *values* (not the display labels "Property Value" / "Best Agent"), matched exactly. The
// banner and the /sell funnel key off this one source of truth rather than duplicating the literals.
export const SellerLeadCaptureTreatments = {
  control: 'control',
  propertyValue: 'property-value',
  bestAgent: 'best-agent',
} as const;

export type SellerLeadCaptureTreatment = (typeof SellerLeadCaptureTreatments)[keyof typeof SellerLeadCaptureTreatments];

// The variation values the HomepageBandVariant flag serves in LaunchDarkly — the kebab-case variation
// *values*, matched exactly. The band keys off this one source of truth rather than duplicating the
// literals; anything else, including an unresolved flag, leaves the visitor unbucketed.
export const HomepageBandTreatments = {
  threeRoutes: 'three-routes',
  singleRoute: 'single-route',
} as const;

export type HomepageBandTreatment = (typeof HomepageBandTreatments)[keyof typeof HomepageBandTreatments];

// The variation values the SuburbSoldBannerVariant flag serves in LaunchDarkly — the kebab-case
// variation *values*, matched exactly. The banner keys its heading off this one source of truth
// rather than duplicating the literals, and treats anything outside this set as "don't render".
export const SuburbSoldBannerTreatments = {
  control: 'control',
  suburbOnly: 'suburb-only',
} as const;

export type SuburbSoldBannerTreatment = (typeof SuburbSoldBannerTreatments)[keyof typeof SuburbSoldBannerTreatments];

type PermanentFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];
type TemporaryFlag = (typeof TempFeatureFlags)[keyof typeof TempFeatureFlags];
export type ExperimentFlag = (typeof ExperimentFlags)[keyof typeof ExperimentFlags];

export type FeatureFlag = PermanentFlag | TemporaryFlag | ExperimentFlag;
